import { isEmpty } from '@jjj/components';
import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';
import { keyBy } from '../../../../../../helpers/core';
import { formatPayload } from '../../../../../../helpers/formatProp';
import { t } from '../../../../../../i18n';

const initState = {
  editForm: null,
  loading: false,
  formInfo: null,
  apiValidationErrors: [],
  baseError: null,
};

function validate(attr, value) {
  let error = '';

  if (attr === 'positions') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', {
        fieldName: t('dash.clients.components.accreditations.positions_label'),
      });
    }
  }

  return error;
}

function onLoadAccreditationRequest(state) {
  return { ...state, loading: true };
}

function onLoadAccreditationSuccess(state, { payload }) {
  const { accreditation, formInfo } = payload;

  formInfo.accreditations = formInfo.accreditations.map(item => ({
    ...item,
    disabled: item.already_applied && item.id !== accreditation.accreditation.id,
  }));

  return {
    ...state,
    editForm: formatPayload(accreditation, validate),
    loading: false,
    formInfo,
  };
}

function onUpdateAccreditationRequest(state) {
  return { ...state };
}

function onUpdateAccreditationSuccess(state, { payload }) {
  const { data } = payload;
  const { accreditation_id, ...otherProps } = data;

  return {
    ...state,
    accreditation: { ...otherProps, accreditation: accreditation_id },
    editForm: null,
  };
}

function onUpdateAccreditationError(state, { payload }) {
  return { ...state, apiValidationErrors: payload, baseError: payload.base?.[0] };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return { ...state, editForm: { ...editForm } };
}

function onClearStore() {
  return { ...initState };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return { ...value, touched: true };
    },
  );

  return { ...state, editForm };
}

export default createReducer(initState, {
  [actions.LOAD_DATA_REQUEST]: onLoadAccreditationRequest,
  [actions.LOAD_DATA_SUCCESS]: onLoadAccreditationSuccess,
  [actions.UPDATE_DATA_SUCCESS]: onUpdateAccreditationSuccess,
  [actions.UPDATE_DATA_ERROR]: onUpdateAccreditationError,
  [actions.UPDATE_DATA_REQUEST]: onUpdateAccreditationRequest,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.TOUCH]: onTouch,
});
